import React from "react";
import "./LabelWithLink.css";

type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
  T,
  Exclude<keyof T, Keys>
> &
  {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>;
  }[Keys];

interface LabelProps {
  labelTitle: string;
  linkTitle: string;
  href?: string;
  tabIndex?: number;
  onClick?: () => void;
}

type HrefOrClick = RequireAtLeastOne<LabelProps, "href" | "onClick">;

const LabelWithLink: React.FC<HrefOrClick> = ({
  labelTitle,
  linkTitle,
  href,
  onClick,
  tabIndex
}) => (
  <div className="styled-label">
    <p>{labelTitle}</p>
    {onClick && (
      <button className="styled-link" type="button" onClick={onClick} tabIndex={tabIndex}>
        {linkTitle}
      </button>
    )}
    {href && (
      <a className="styled-link" href={href} tabIndex={tabIndex}>
        {linkTitle}
      </a>
    )}
  </div>
);

export default LabelWithLink;
